module.exports = ".list:hover{\r\n    border-top: 1px solid black;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/staff-criminal-proceedings/view-criminal-emp/view-criminal-emp.component.css
// module id = ./src/app/pages/functions/staff-criminal-proceedings/view-criminal-emp/view-criminal-emp.component.css
// module chunks = main